import axios from "axios";
import Config from "../Config/Config";

const baseURL = (Config.baseUrl || "").replace(/\/+$/, "");

export const publicAxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
  withCredentials: false,
  headers: {
    Accept: "application/json",
  },
});

export default class PublicAPIService {
  openOrderAccessHeaders = (accessToken) => ({
    "X-Open-Order-Access-Token": accessToken,
  });

  getOpenOrderCatalog = async () =>
    publicAxiosInstance.get(`${baseURL}/open-order/catalog`);

  createOpenOrderQuote = async (data) =>
    publicAxiosInstance.post(`${baseURL}/open-order/quote`, data, {
      headers: { "Content-Type": "application/json" },
    });

  getOpenOrderFedexRates = async (data) =>
    publicAxiosInstance.post(`${baseURL}/open-order/fedex-rates`, data, {
      headers: { "Content-Type": "application/json" },
    });

  submitOpenOrder = async (data) =>
    publicAxiosInstance.post(`${baseURL}/open-order/submit`, data, {
      headers: { "Content-Type": "application/json" },
    });

  getOpenOrderStatus = async (accessToken) =>
    publicAxiosInstance.get(`${baseURL}/open-order/status`, {
      headers: this.openOrderAccessHeaders(accessToken),
    });

  getOpenOrderView = async (accessToken) =>
    publicAxiosInstance.get(`${baseURL}/open-order/view`, {
      headers: this.openOrderAccessHeaders(accessToken),
    });

  retryOpenOrderCheckout = async (accessToken, data) =>
    publicAxiosInstance.post(`${baseURL}/open-order/checkout`, data, {
      headers: {
        "Content-Type": "application/json",
        ...this.openOrderAccessHeaders(accessToken),
      },
    });

  getOpenOrderReceipt = async (accessToken) =>
    publicAxiosInstance.get(`${baseURL}/open-order/receipt`, {
      headers: this.openOrderAccessHeaders(accessToken),
    });
}
